import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetDatabaseNamesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DatasetExport/GetDatabaseNames`,
});

export const GetDatabaseYearsRequest = (databaseName) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DatasetExport/GetDatabaseYears`,
	params: { databaseName }
});

export const GetDatabaseMonthsRequest = (databaseName, year) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DatasetExport/GetDatabaseMonths`,
	params: { databaseName, year }
});

export const DownloadDatabaseRequest = (databaseName, month, year, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DatasetExport/DownloadDatabase`,
	params: { databaseName, month, year, userId }
});
